// DO NOT EDIT -- generated from Go package fs/api/segment/convert

import * as segmentproto from '@fullstory/proto/fs/api/segment';
import * as schema from './fs_shared_schema';


//////////
// Maps //
//////////

// Should always be in sync with FromPlatformMap
export const ToPlatformMap: Map<schema.PlatformEnum, segmentproto.Platform> = new Map([
  [schema.PlatformEnum.PlatformWeb, 1],
  [schema.PlatformEnum.PlatformNativeMobile, 2],
  [schema.PlatformEnum.PlatformServer, 3],
]);

// Should always be in sync with ToPlatformMap
export const FromPlatformMap: Map<segmentproto.Platform, schema.PlatformEnum> = new Map([
  [1, schema.PlatformEnum.PlatformWeb],
  [2, schema.PlatformEnum.PlatformNativeMobile],
  [3, schema.PlatformEnum.PlatformServer],
]);
